export default __webpack_public_path__ + "static/Calming-54f7b6c02f17f30c9f2730c4999e5cca.png";